import React from "react";
import * as R from "ramda";

import Fields from "components/guides/Fields";
import { useFields } from "queries/fields";

export default function Attachments() {
  const { data: attachmentFields = [] } = useFields({
    select: R.filter(R.both(R.propEq("attachment", "field_type"), R.propEq("parent_id", null))),
  });

  return (
    <div className="admin-container">
      <h1>Attachments</h1>
      <Fields fields={attachmentFields} hideIfUnanswered behaviorType="disabled" />
    </div>
  );
}
